import { LOCALISATION_CONFIG } from "@/shared/config/localisation";

type MotorQuoteItem = {
  label?: string;
  value?: unknown;
  premium?: number | string | null;
  amount?: number | string | null;
  currency?: string | null;
  [key: string]: unknown;
};

type MotorQuoteSection = {
  title?: string;
  items?: MotorQuoteItem[];
};

type MotorQuoteResponse = {
  insurer?: {
    name?: string;
    insurer_id?: number | string | null;
    insurer_sequence?: number | null;
  };
  plan?: {
    name?: string;
    id?: number | string | null;
    description?: string | null;
    price?: {
      amount?: number | string | null;
      currency?: string | null;
      vat?: number | string | null;
      amount_with_vat?: number | string | null;
    };
  };
  price?: {
    amount?: number | string | null;
    currency?: string | null;
    vat?: number | string | null;
    amount_with_vat?: number | string | null;
  };
  sections?: MotorQuoteSection[];
  [key: string]: unknown;
};

const toNullableValue = (value: unknown) => {
  if (value === undefined) return null;
  return value;
};

export function normalizeMotorQuote(quote: MotorQuoteResponse) {
  const rootPrice = quote.price ?? quote.plan?.price ?? {};
  const normalizedCurrency =
    rootPrice.currency ?? quote.plan?.price?.currency ?? LOCALISATION_CONFIG.currencyCode;

  return {
    ...quote,
    plan: {
      ...(quote.plan ?? {}),
      id: quote.plan?.id ?? "",
      name: quote.plan?.name ?? "",
      price: {
        amount: toNullableValue(rootPrice.amount),
        currency: toNullableValue(normalizedCurrency),
        vat: toNullableValue(rootPrice.vat),
        amount_with_vat: toNullableValue(rootPrice.amount_with_vat),
      },
    },
    sections: (quote.sections ?? []).map((section) => ({
      ...section,
      items: (section.items ?? []).map((item) => ({
        ...item,
        amount: item.amount ?? item.premium ?? null,
        currency: item.currency ?? normalizedCurrency,
      })),
    })),
  };
}
